const bankValidators = require('us-bank-account-validator')

import confirmationCodeForm from './confirmationCodeForm.html'
import ConfirmationCodeFormController from './confirmationCodeForm.ctrl'

/** 
 * @typedef DirectDepositInfo
 * @property {string} bankName
 * @property {'Checking'|'Savings'} accountType
 * @property {string} routingNumber
 * @property {string} accountNumber
 */

class DirectDepositController {
    /* @ngInject */
  ADDITIONAL_VALID_ROUTING_NUMBERS = [
    '067092886',
    '124303201',
    '125109006',
    '125108997',
    '064209588', // Thread Bank
    '031101334', // SoFi bank NA
    '101015347', // NBKC Bank
    '124303243', // American Express National
    '051504759', // MVB Bank
  ]

  /**
   * 
   * @param {*} PayrollService 
   * @param {*} $mdDialog 
   * @param {*} $mdToast 
   * @param {*} userId 
   * @param {() => void} onDirectDepositSaveSuccess 
   */
  constructor (PayrollService, $mdDialog, $mdToast, userId, onDirectDepositSaveSuccess) {
    'ngInject'
    this.PayrollService = PayrollService
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.userId = userId
    this.routingNumberValid = true
    this.onDirectDepositSaveSuccess = onDirectDepositSaveSuccess

    /** @type {DirectDepositInfo} */
    this.directDepositInfo = {
      bankName: null,
      accountType: null,
      routingNumber: null,
      accountNumber: null
    }
    this.directDepositFormSubmitted = false
  }

  validateRoutingNumber () {
    this.routingNumberValid = this.isRoutingNumberValid(this.directDepositInfo.routingNumber);
    this.directDepositForm.routingNumber.$setValidity('', this.routingNumberValid)
  }

  isRoutingNumberValid(routingNumber) {
    const isAdditionalValidNumber = this.ADDITIONAL_VALID_ROUTING_NUMBERS.indexOf(routingNumber) >= 0;
    return isAdditionalValidNumber || bankValidators.routingNumber(routingNumber).isValid
  }

  async attemptSaveDirectDepositInfo () {
    const { accountNumber, bankName, routingNumber, accountType } = this.directDepositInfo
    if ([accountNumber, bankName, routingNumber, accountType].includes(null)) {
      // If any of the required fields wasn't passed, remain on the first step of the form
      return
    }

    await this.PayrollService.sendConfirmationCode(this.userId)
    this.openConfirmationCodeModal()
  }

  /**
   * Save the Users Direct Deposit Info
   * @param {DirectDepositInfo} directDepositInfo - The users DD info to save
   * @param {string} confirmationCode - The confirmation code required to confirm the addition of new banking info for the user
   */
  async saveDirectDepositInfo (directDepositInfo, confirmationCode) {
    try {
      this.directDepositFormSubmitted = true
      await this.PayrollService.saveDirectDepositInfo(this.userId, {...directDepositInfo, confirmationCode})
      this.$mdDialog.hide()
      this.$mdToast.show(this.$mdToast.simple('Direct deposit info saved').hideDelay(5000))
      this.onDirectDepositSaveSuccess()
    } catch (e) {
      this.directDepositFormSubmitted = false
      throw e
    }

    
  }

  closeDialog () {
    this.$mdDialog.cancel()
  }

  openConfirmationCodeModal () {
    this.$mdDialog.show({
      parent: document.body,
      template: confirmationCodeForm,
      controller: ConfirmationCodeFormController,
      controllerAs: 'l',
      locals: {
        handleSubmitCode: async (confirmationCode) => 
          await this.saveDirectDepositInfo(this.directDepositInfo, confirmationCode)
      }
    })
  }
  
}

export default DirectDepositController
